export default __webpack_public_path__ + "static/media/bg_ok.69d4a2ff.png";